import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as d, normalizeClass as l, createElementVNode as n } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconMapPinFilled",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m6 11 .263.35v-.001l.004-.002.01-.008.036-.028.133-.105a16.107 16.107 0 0 0 1.881-1.79c1.01-1.137 2.11-2.743 2.11-4.416a4.438 4.438 0 0 0-8.874 0c0 1.673 1.1 3.28 2.11 4.416a16.107 16.107 0 0 0 2.014 1.895l.023.018.013.01.01.008.003.002h.001L6 11Zm0 0-.263.35c.156.117.37.117.526 0L6 11Zm0-7.063a1.063 1.063 0 1 1 0 2.126 1.063 1.063 0 0 1 0-2.125ZM7.938 5a1.938 1.938 0 1 0-3.876 0 1.938 1.938 0 0 0 3.875 0Z",
  fill: "currentColor"
}, null, -1), m = [
  _
];
function p(e, u, i, f, h, a) {
  return d(), r("svg", {
    "aria-label": i.ariaLabel,
    class: l([a.iconSizeClass, "d-icon d-icon--map-pin-filled"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Map Pin Filled",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, m, 10, c);
}
const I = /* @__PURE__ */ o(s, [["render", p]]);
export {
  I as default
};
//# sourceMappingURL=map-pin-filled.js.map
